import User from './User.container';

export default User;
